import { useSearchspringTrendingContext } from "@app/providers/searchspring";
import React from "react";

export function SearchTrending() {
  const { response } = useSearchspringTrendingContext();

  return (
    <div className="flex flex-col gap-4">
      <p className="h4">Popular Searches</p>
      <hr className="border-neutrals-grey-4" />

      <div className="flex flex-col gap-2">
        {response?.trending?.queries?.map((trending) => (
          <a
            href={`/search?query=${trending.searchQuery}`}
            className="text-neutrals-grey-8 hover:text-neutrals-grey-10"
            key={trending.searchQuery}
          >
            <span className="btn-underline-hover">{trending.searchQuery}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
